import { render, staticRenderFns } from "./TermSimilarity.vue?vue&type=template&id=5d283815&lang=pug&"
import script from "./TermSimilarity.vue?vue&type=script&lang=js&"
export * from "./TermSimilarity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports